import { useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import Footer from '../Footer';
import MessageInput from '../MessageInput';
import OverlapMenuContent from '../OverlapMenuContent/OverlapMenuContent';
import Header from '../OverlapMenuHeader';

const OverlapMenu = () => {
  const { ui } = useStores();
  const {
    source,
    fontFamily,
    window: { background, borderRadius, boxShadow },
    footer,
    overlapMenu: { chatOptions, contentAdditionalText }
  } = useConfig();
  const configProjectName = source.split('_')[0].toLowerCase();
  const [chatTab, setChatTab] = React.useState(chatOptions.headerChatButton.selected);

  const handleTab = value => {
    if (chatOptions.enabled) {
      setChatTab(value);
      if (value) {
        ui.closeOverlapMenuModal();
      }
      return null;
    }

    return null;
  };

  return useObserver(() => (
    <Root
      fontFamily={fontFamily}
      background={background}
      borderRadius={borderRadius}
      boxShadow={boxShadow}
    >
      <Header selectedTab={chatTab} tabClick={handleTab} />
      {chatOptions.enabled && chatTab ? (
        <Content background={background}>
          <iframe
            id="tpbot"
            title="tpbot"
            src={`https://jointpoly-prd.mybluemix.net/${configProjectName}/`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          />
        </Content>
      ) : (
        <Content background={background}>
          <MenuContentWrapper>
            <OverlapMenuContent openChat={() => handleTab(true)} />
          </MenuContentWrapper>

          {((contentAdditionalText && ui.isVisibleMessageInput) || !contentAdditionalText) && (
            <MessageInputWrapper borderRadius={borderRadius} isFooter={footer.enabled}>
              <MessageInput />
            </MessageInputWrapper>
          )}
        </Content>
      )}
      {footer.enabled && <Footer />}
    </Root>
  ));
};

const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  width: 100%;
  min-width: 100%;
  font-family: ${props => props.fontFamily};
  border-radius: ${props => props.borderRadius}px;
  box-shadow: ${props => props.boxShadow};
`;

const Content = styled.main`
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: auto;
  min-width: auto;
  height: auto;
  min-height: auto;
  background: ${props => props.background};
  border: none;
  overflow-y: auto;
  overflow-x: hidden;

  & > iframe {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
  }
`;

const MenuContentWrapper = styled.div`
  position: relative;
  flex: 1 0 auto;
`;

const MessageInputWrapper = styled.div`
  border-radius: ${({ borderRadius, isFooter }) =>
    isFooter ? '0' : `0 0 ${borderRadius}px ${borderRadius}px`};
  overflow: hidden;
`;

export default OverlapMenu;
